/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';
import { selectWalletInfo } from '../../../../data-layer/cpa/selectors';
import { CpaStatus } from '../../../../data-layer/cpa/types';
import { useSelector } from '../../../../data-layer/useSelector';
import { useOpenDialog } from '../../../../routing/ModalRoute';
import { DIALOGS } from '../../../../routing/constants';
import { useCurrentUser } from '../../../../routing/users/useCurrentUser';
import { contentActionsService } from '../../../../utils/ContentActionsService/ContentActionsService';
import { useEventSource } from '../../../../utils/LocationContext';
import { EventSource } from '../../../../utils/analyticsService';

export const useCpaRewardHandlers = () => {
    const currentUser = useCurrentUser();
    const cpaStatus = currentUser?.cpaStatus;
    const walletInfo = useSelector(selectWalletInfo);

    const openDialog = useOpenDialog();
    const { eventSource } = useEventSource();

    const logClick = useCallback(() => {
        contentActionsService.trackRewardButtonClick({
            status: cpaStatus,
            screen: eventSource || EventSource.PROFILE,
        });
    }, [cpaStatus, eventSource]);

    const getDialog = useCallback(() => {
        if (cpaStatus === CpaStatus.TRIAL) {
            if (walletInfo?.contractAvailable) {
                return DIALOGS.CPA_TRIAL_REGISTRATION;
            }

            return DIALOGS.CPA_TRIAL;
        }

        if (cpaStatus === CpaStatus.MODERATION) {
            return DIALOGS.CPA_MODERATION;
        }

        if (cpaStatus === CpaStatus.DECLINED) {
            return DIALOGS.CPA_DECLINED;
        }

        if (cpaStatus === CpaStatus.ACCEPTED) {
            return DIALOGS.CPA_ACCEPTED;
        }

        return DIALOGS.CPA_TRIAL;
    }, [cpaStatus, walletInfo?.contractAvailable]);

    const openInfoDialog = useCallback(() => {
        logClick();

        openDialog(getDialog());
    }, [getDialog, logClick, openDialog]);

    return {
        openInfoDialog,
    };
};
